import React from 'react';
import { Link } from 'react-router-dom';
import './Page.css';

const About = () => {
  return (
    <div className="page">
      <section className="page-hero page-hero--red">
        <div className="container">
          <h1>Built by Practitioners. Focused on Careers.</h1>
        </div>
      </section>

      <section className="page-content section">
        <div className="container">
          <div className="content-wrapper">
            <p className="lead-text">
              We are building a modern education platform focused on Data, Analytics, and AI careers. Our mission is to help learners gain practical skills, confidence, and clarity in their professional journey.
            </p>

            <div className="about-section">
              <h2>Our Mission</h2>
              <p>
                To bridge the gap between academic learning and industry expectations by providing practical, mentor-led programs that prepare learners for real-world data and AI careers.
              </p>
            </div>

            <div className="about-section">
              <h2>Our Approach</h2>
              <p>
                We believe in learning by doing. Our curriculum is designed by industry practitioners who understand what skills are actually needed in the workplace. We focus on hands-on training, real projects, and continuous mentorship to ensure our learners are job-ready.
              </p>
            </div>

            <div className="about-section">
              <h2>Our Commitment</h2>
              <p>
                We are committed to your success. From the moment you enroll, we provide structured learning, regular feedback, career guidance, and ongoing support to help you achieve your professional goals.
              </p>
            </div>

            <div className="location-section">
              <h2>Our Location</h2>
              <p>
                We are an online learning platform serving learners across India. We have plans to establish an offline learning center in <strong>Bhubaneswar, Odisha</strong> to provide in-person learning opportunities for local students.
              </p>
            </div>

            <div className="cta-section">
              <h2>Join Our Community</h2>
              <p>Be part of a growing community of data professionals and AI enthusiasts.</p>
              <div className="cta-buttons">
                <Link to="/academy/contact" className="btn btn-primary btn-large">
                  Get in Touch
                </Link>
                <Link to="/academy/data-analytics-course" className="btn btn-secondary btn-large">
                  Explore Programs
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;



